<agpr-take-over-panel
    class="agpr-addPrivateData-dialog"
    [id]="id"
    [header]="systemEntity?.entityType === entityType.CONTACT ? 'Discover.addPrivateDataDialog.contact.header' : 'Discover.addPrivateDataDialog.outlet.header'"
    (visibleChange)="close()"
    [overlayContainer]="overlayContainer"
    [hideSlideOverlay]="hideSlideOverlay"
    [animationTrigger]="animationTrigger"
    [width]="60"
>
    <div class="agpr-addPrivateData-scrollpanel">
        <agpr-scroll-panel>
            <agpr-message [severity]="messageSeverityEnum.info">
                {{ 'Discover.addPrivateDataDialog.banner' | localize }}
            </agpr-message>

            <div class="agpr-flexContainer">
                <div class="agpr-halfWidth">
                    <div class="agpr-addPrivateData-fieldLabel">
                        <label [for]="id + '_emailChips_textInput'">
                            {{ 'Discover.contactEditor.fields.email.label' | localize }}
                        </label>
                    </div>
                    <agpr-handles-chips
                        [id]="id + '_emailChips'"
                        class="agpr-addPrivateData-inputable"
                        placeholder="Discover.contactEditor.fields.email.placeholder"
                        [ngModel]="focusedEntity.handles"
                        [handleType]="handleTypeEnum.EMAIL"
                        [addPrivateData]="true"
                        errorMessage="Discover.contactEditor.errors.email.format"
                        (add)="addHandle($event)"
                        (remove)="removeHandle($event)"
                        (handlesChanged)="setPreferredEmail($event)"
                        addButtonTooltip="Discover.contactEditor.fields.email.label.add"
                    ></agpr-handles-chips>
                </div>

                <div class="agpr-halfWidth">
                    <div class="agpr-addPrivateData-fieldLabel">
                        <label [for]="id + '_phoneChips_textInput'">
                            {{ 'Discover.contactEditor.fields.phone.label' | localize }}
                        </label>
                    </div>
                    <agpr-handles-chips
                        [id]="id + '_phoneChips'"
                        class="agpr-addPrivateData-inputable"
                        placeholder="Discover.contactEditor.fields.phone.placeholder"
                        [ngModel]="focusedEntity.handles"
                        [handleType]="handleTypeEnum.PHONE"
                        [maxLength]="64"
                        [addPrivateData]="true"
                        (add)="addHandle($event)"
                        (remove)="removeHandle($event)"
                        addButtonTooltip="Discover.contactEditor.fields.phone.label.add"
                    ></agpr-handles-chips>
                </div>
            </div>

            <div class="agpr-flexContainer">
                <div class="agpr-halfWidth">
                    <div class="agpr-addPrivateData-fieldLabel">
                        <label [for]="id + '_websiteChips_textInput'">
                            {{ 'Discover.contactEditor.fields.website.label' | localize }}
                        </label>
                    </div>
                    <agpr-handles-chips
                        [id]="id + '_websiteChips'"
                        class="agpr-addPrivateData-inputable"
                        placeholder="Discover.contactEditor.fields.website.placeholder"
                        [ngModel]="focusedEntity.handles"
                        [handleType]="handleTypeEnum.WEBSITE"
                        [addPrivateData]="true"
                        (add)="addHandle($event)"
                        (remove)="removeHandle($event)"
                        addButtonTooltip="Discover.contactEditor.fields.website.label.add"
                    ></agpr-handles-chips>
                </div>
            </div>

            <agpr-panel
                class="agpr-addPrivateData-socialMedia"
                header="Discover.contactEditor.panels.socialMedia"
                [toggleable]="false"
                [contentPadding]="false"
            >
                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_twitterChips_textInput'">
                                {{ 'Common.handleTypes.TWITTER' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_twitterChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.twitter.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.TWITTER"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.twitter.add"
                        ></agpr-handles-chips>
                    </div>
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_facebookChips_textInput'">
                                {{ 'Common.handleTypes.FACEBOOK' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_facebookChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.facebook.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.FACEBOOK"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.facebook.add"
                        ></agpr-handles-chips>
                    </div>
                </div>
                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_linkedinChips_textInput'">
                                {{ 'Common.handleTypes.LINKEDIN' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_linkedinChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.linkedin.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.LINKEDIN"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.linkedin.add"
                        ></agpr-handles-chips>
                    </div>
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_instagramChips_textInput'">
                                {{'Common.handleTypes.INSTAGRAM' | localize}}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_instagramChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.instagram.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.INSTAGRAM"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.instagram.add"
                        ></agpr-handles-chips>
                    </div>
                </div>
                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_blueskyChips_textInput'">
                                {{ 'Common.handleTypes.BLUESKY' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_blueskyChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.bluesky.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.BLUESKY"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.bluesky.add"
                        ></agpr-handles-chips>
                    </div>
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_youtubeChips_textInput'">
                                {{ 'Common.handleTypes.YOUTUBE' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_youtubeChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.youtube.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.YOUTUBE"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.youtube.add"
                        ></agpr-handles-chips>
                    </div>
                </div>
                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <div class="agpr-addPrivateData-fieldLabel">
                            <label [for]="id + '_tiktokChips_textInput'">
                                {{ 'Common.handleTypes.TIKTOK' | localize }}
                            </label>
                        </div>
                        <agpr-handles-chips
                            [id]="id + '_tiktokChips'"
                            class="agpr-addPrivateData-inputable"
                            placeholder="Discover.contactEditor.fields.tiktok.placeholder"
                            [ngModel]="focusedEntity.handles"
                            [handleType]="handleTypeEnum.TIKTOK"
                            [addPrivateData]="true"
                            (add)="addHandle($event)"
                            (remove)="removeHandle($event)"
                            addButtonTooltip="Discover.contactEditor.fields.tiktok.add"
                        ></agpr-handles-chips>
                    </div>
                </div>
            </agpr-panel>

            <agpr-panel
                class="agpr-addPrivateData-address"
                header="Discover.contactEditor.panels.address"
                [toggleable]="false"
                [contentPadding]="false"
            >
                <div
                    *ngIf="systemEntity.entityType === entityType.CONTACT && contactHasSystemAddresses"
                    class="agpr-addPrivateData-addressListItem"
                >
                    {{ $any(systemEntity).selectedEmployment.outlet?.addressLine1 }}<span *ngIf="$any(systemEntity).selectedEmployment.outlet?.addressLine1 && $any(systemEntity).selectedEmployment.outlet?.addressLine2">, </span>{{ $any(systemEntity).selectedEmployment.outlet?.addressLine2 }}
                    <span *ngIf="($any(systemEntity).selectedEmployment.outlet?.addressLine1 || $any(systemEntity).selectedEmployment.outlet?.addressLine2) && ($any(systemEntity).selectedEmployment.outlet?.geography?.keyString || $any(systemEntity).selectedEmployment.outlet?.postalCode)"><br></span>
                    {{ $any(systemEntity).selectedEmployment.outlet?.geography?.keyString }}<span *ngIf="$any(systemEntity).selectedEmployment.outlet?.geography?.keyString && $any(systemEntity).selectedEmployment.outlet?.postalCode">, </span>{{ $any(systemEntity).selectedEmployment.outlet?.postalCode }}
                </div>
                <div
                    *ngIf="systemEntity.entityType === entityType.OUTLET"
                    class="agpr-addPrivateData-addressListItem"
                >
                    {{ systemEntity.addressLine1 }}<span *ngIf="systemEntity.addressLine1">,</span> {{ systemEntity.addressLine2 }}
                    <span *ngIf="(systemEntity.addressLine1 || systemEntity.addressLine2) && (systemEntity.geography?.keyString || systemEntity.postalCode)"><br></span>
                    {{ systemEntity.geography?.keyString }}<span *ngIf="systemEntity.geography?.keyString && systemEntity.postalCode">,</span> {{ systemEntity.postalCode }}
                </div>
                <div
                    *ngFor="let address of privateData?.addresses; index as i"
                    class="agpr-addPrivateData-addressListItem"
                >
                    {{ address.addressLine1 }}<span *ngIf="address.addressLine1 && address.addressLine2">, </span>{{ address.addressLine2 }}
                    <span *ngIf="(address.addressLine1 || address.addressLine2) && (address.geography?.keyString || address.postalCode)"><br></span>
                    {{ address.geography?.keyString }}<span *ngIf="address.geography?.keyString && address.postalCode">, </span>{{ address.postalCode }}
                    <span
                        role="img"
                        class="agpr-addPrivateData-badge fa-regular fa-duotone fa-shield-keyhole"
                        agprTooltip="Discover.addPrivateDataDialog.privateData"
                        tooltipPosition="top"
                    ></span>
                    <div class="agpr-addPrivateData-contextMenu">
                        <agpr-button
                            [id]="i + '_deleteAddress'"
                            class="agpr-addPrivateData-contextMenu-trash"
                            [style]="buttonTypes.icon"
                            icon="fa-regular fa-duotone fa-trash-can"
                            tooltip="Discover.addPrivateDataDialog.removeAddress"
                            tooltipPosition="top"
                            (click)="removeAddress(address)"
                        ></agpr-button>
                    </div>
                </div>

                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <agpr-text-input
                            [id]="id + '_addressLine1'"
                            label="Discover.contactEditor.fields.addressLine1.label"
                            placeholder="Discover.contactEditor.fields.addressLine1.placeholder"
                            [bottomMargin]="false"
                            [maxLength]="100"
                            [(ngModel)]="focusedEntity.addressLine1"
                            (ngModelChange)="updateAddressDirtyFlag()"
                        ></agpr-text-input>
                    </div>
                    <div class="agpr-halfWidth">
                        <agpr-text-input
                            [id]="id + '_addressLine2'"
                            label="Discover.contactEditor.fields.addressLine2.label"
                            placeholder="Discover.contactEditor.fields.addressLine2.placeholder"
                            [bottomMargin]="false"
                            [maxLength]="100"
                            [(ngModel)]="focusedEntity.addressLine2"
                            (ngModelChange)="updateAddressDirtyFlag()"
                        ></agpr-text-input>
                    </div>
                </div>

                <div class="agpr-flexContainer">
                    <div class="agpr-halfWidth">
                        <agpr-autocomplete
                            [id]="id + '_location'"
                            class="agpr-addPrivateData-inputable"
                            labelField="displayString"
                            label="Discover.contactEditor.fields.location.label"
                            placeholder="Discover.contactEditor.fields.location.placeholder"
                            [(ngModel)]="focusedEntity.geography"
                            [suggestionsFetcher]="journodexRegionsService.searchGeographicLocations.bind(journodexRegionsService)"
                            (itemSelected)="updateAddressDirtyFlag()"
                            [clearOnBlur]="false"
                        ></agpr-autocomplete>
                    </div>
                    <div class="agpr-halfWidth">
                        <agpr-text-input
                            [id]="id + '_postalCode'"
                            label="Discover.contactEditor.fields.postalcode.label"
                            placeholder="Discover.contactEditor.fields.postalcode.placeholder"
                            [(ngModel)]="focusedEntity.postalCode"
                            (ngModelChange)="updateAddressDirtyFlag()"
                            [bottomMargin]="false"
                            [maxLength]="100"
                        ></agpr-text-input>
                    </div>
                </div>

                <agpr-button
                    [style]="buttonTypes.icon"
                    [icon]="'fa-regular fa-duotone fa-square-plus'"
                    class="agpr-addPrivateData-addAddressButton"
                    [disabled]="!addressFieldsDirty"
                    (click)="addAddress()"
                ></agpr-button>
            </agpr-panel>

            <agpr-panel
                class="agpr-addPrivateData-personalizations"
                header="Discover.contactEditor.panels.distributionPersonalizations"
                [tooltip]="systemEntity.entityType === entityType.CONTACT ?
                    'Discover.contactEditor.panels.distributionPersonalizations.contact.tooltip' : 'Discover.contactEditor.panels.distributionPersonalizations.outlet.tooltip'"
                [toggleable]="false"
            >
                @if (systemEntity.entityType === entityType.CONTACT) {
                    <agpr-text-input
                        [id]="id + '_personalization_namePrefix'"
                        class="agpr-addPrivateData-personalizations-medium"
                        label="Discover.contactEditor.fields.namePrefix.label"
                        [(ngModel)]="privateData.namePrefix"
                        (ngModelChange)="updateDirtyFlag()"
                        placeholder="Discover.contactEditor.fields.namePrefix.placeholder"
                        [bottomMargin]="false"
                        [maxLength]="100"
                    ></agpr-text-input>

                    <agpr-text-input
                        [id]="id + '_personalization_firstName'"
                        class="agpr-addPrivateData-personalizations-medium"
                        label="Discover.contactEditor.fields.firstName.label"
                        [(ngModel)]="privateData.firstName"
                        (ngModelChange)="updateDirtyFlag()"
                        placeholder="Discover.contactEditor.fields.firstName.placeholder"
                        [bottomMargin]="false"
                        [maxLength]="100"
                    ></agpr-text-input>

                    <agpr-text-input
                        [id]="id + '_personalization_lastName'"
                        class="agpr-addPrivateData-personalizations-medium"
                        label="Discover.contactEditor.fields.lastName.label"
                        [(ngModel)]="privateData.lastName"
                        (ngModelChange)="updateDirtyFlag()"
                        placeholder="Discover.contactEditor.fields.lastName.placeholder"
                        [bottomMargin]="false"
                        [maxLength]="100"
                    ></agpr-text-input>

                    <agpr-text-input
                        [id]="id + '_personalization_outletName'"
                        class="agpr-addPrivateData-personalizations-medium"
                        label="Discover.contactEditor.fields.outletName.label"
                        [(ngModel)]="privateData.outletName"
                        (ngModelChange)="updateDirtyFlag()"
                        placeholder="Discover.contactEditor.fields.outletName.placeholder"
                        [bottomMargin]="false"
                        [maxLength]="100"
                    ></agpr-text-input>
                } @else {
                    <agpr-text-input
                        [id]="id + '_personalization_outletName'"
                        class="agpr-addPrivateData-personalizations-large"
                        label="Discover.contactEditor.fields.outletName.label"
                        [(ngModel)]="privateData.outletName"
                        (ngModelChange)="updateDirtyFlag()"
                        placeholder="Discover.contactEditor.fields.outletName.placeholder"
                        [bottomMargin]="false"
                        [maxLength]="100"
                    ></agpr-text-input>
                }
            </agpr-panel>

            <agpr-panel
                header="Discover.userNotes.header"
                [toggleable]="false"
                [contentPadding]="false"
            >
                <ng-template #panelHeader>
                    <div class="header-container">
                        <agpr-button
                            class="notesIconStyle fa-regular fa-duotone fa-square-plus"
                            [agprTooltip]="'Discover.userNotes.addNote'"
                            tooltipPosition="top"
                            [style]="buttonTypes.icon"
                            (click)="
                                $event.stopPropagation();
                                userNotesComponent.addNote()
                            "
                        ></agpr-button>
                    </div>
                </ng-template>
                <agpr-user-notes
                    #userNotesComponent
                    [id]="id + '_userNotes'"
                    [userNotes]="privateData.notes"
                    [currentUser]="currentUser"
                    [panelStyle]="true"
                    [scrolling]="false"
                    (notesChanged)="modifyNotes($event)"
                ></agpr-user-notes>
            </agpr-panel>
        </agpr-scroll-panel>
    </div>

    <ng-template #takeOverFooterLeft>
        <agpr-button
            [id]="id + '_cancelButton'"
            label="cancel"
            [style]="buttonTypes.secondary"
            (click)="hideSlideOverlay = true;"
        ></agpr-button>
    </ng-template>

    <ng-template #takeOverFooterRight>
        <agpr-button
            [id]="id + '_saveButton'"
            [style]="buttonTypes.primary"
            label="Discover.addPrivateDataDialog.ok"
            [disabled]="!privateDataDirty && !preferredEmail"
            (click)="updatePrivateData()"
        ></agpr-button>
    </ng-template>
</agpr-take-over-panel>
